// Simple service for displaying notifications
class ToastService {
    private toastContainer: HTMLElement | null = null;

    constructor() {
        this.createToastContainer();
    }

    private createToastContainer() {
        // Create toast container if it doesn't exist yet
        this.toastContainer = document.getElementById('toast-container');
        if (!this.toastContainer) {
            this.toastContainer = document.createElement('div');
            this.toastContainer.id = 'toast-container';
            this.toastContainer.style.position = 'fixed';
            this.toastContainer.style.top = '20px';
            this.toastContainer.style.right = '20px';
            this.toastContainer.style.zIndex = '9999';
            document.body.appendChild(this.toastContainer);
        }
    }

    showSuccess(message: string, duration: number = 3000) {
        this.showToast(message, 'success', duration);
    }

    showError(message: string, duration: number = 5000) {
        this.showToast(message, 'error', duration);
    }

    showInfo(message: string, duration: number = 3000) {
        this.showToast(message, 'info', duration);
    }

    private showToast(message: string, type: 'success' | 'error' | 'info', duration: number) {
        if (!this.toastContainer) return;

        const toast = document.createElement('div');
        toast.className = `toast toast-${type}`;
        toast.textContent = message;

        // Toast styles
        toast.style.padding = '12px 20px';
        toast.style.marginBottom = '10px';
        toast.style.borderRadius = '4px';
        toast.style.color = 'white';
        toast.style.fontSize = '14px';
        toast.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
        toast.style.opacity = '0';
        toast.style.transition = 'opacity 0.3s ease-in-out';

        // Different styles for different types
        switch (type) {
            case 'success':
                toast.style.backgroundColor = '#4caf50';
                break;
            case 'error':
                toast.style.backgroundColor = '#f44336';
                break;
            case 'info':
                toast.style.backgroundColor = '#2196f3';
                break;
        }

        this.toastContainer.appendChild(toast);

        // Appearance animation
        setTimeout(() => {
            toast.style.opacity = '1';
        }, 100);

        // Automatic removal after specified time
        setTimeout(() => {
            toast.style.opacity = '0';
            setTimeout(() => {
                if (toast.parentNode === this.toastContainer) {
                    this.toastContainer!.removeChild(toast);
                }
            }, 300);
        }, duration);
    }
}

// Export singleton service instance
export const toastService = new ToastService();